export default __webpack_public_path__ + "static/install-linkerd-72fdec49d09b40484ea0bc885337b193.webp";